import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import NavLogo from "../../assets/images/favicon/primary-logo-400X116.svg";
import { loginWithEmailApi } from "../../api/authService";
import { withRouter } from "../../utils/withRouter";
import FullPageLoader from "../../common/FullPageLoader";
import {
  GoogleReCaptchaProvider,
  useGoogleReCaptcha,
} from "react-google-recaptcha-v3";

class Login extends Component {
  state = {
    loading: false,
  };
  componentDidMount() {
    const token = localStorage.getItem("token");
    if (token) {
      this.props.navigate("/");
    }
  }
  validateForm = (values) => {
    const errors = {};
    if (!values.email) errors.email = "Email is required";
    if (!values.password) errors.password = "Password is required";
    return errors;
  };

  render() {
    const { loading } = this.state;

    return (
      <>
        {loading && <FullPageLoader text="Signing in..." />}
        <div className="auth">
          <div className="auth_left">
            <div className="card">
              <div className="text-center mb-2">
                <Link className="header-brand" to="/">
                  <img src={NavLogo} alt="Logo" height="70" />
                </Link>
              </div>
              <div className="card-body">
                <div className="card-title">Login to your account</div>
                <Formik
                  initialValues={{
                    email: "",
                    password: "",
                    authError: "",
                  }}
                  validate={this.validateForm}
                  onSubmit={async (
                    values,
                    { setSubmitting, setFieldError, setStatus },
                  ) => {
                    this.setState({ loading: true });
                    try {
                      setSubmitting(true);
                      const executeRecaptcha = this.props.executeRecaptcha;
                      if (!executeRecaptcha) {
                        this.setState({ loading: false });

                        setSubmitting(false);

                        setFieldError(
                          "authError",
                          "Security verification is not ready. Please try again.",
                        );

                        return;
                      }
                      const recaptchaToken =
                        await executeRecaptcha("login_form");
                      const response = await loginWithEmailApi({
                        email: values.email,
                        password: values.password,
                        recaptchaToken,
                      });

                      const data = response?.data || {};
                      const token = data?.token || null;
                      const user = data?.user || null;
                      const permissionsRaw = data?.permissions || [];

                      const isSuccess =
                        response.status >= 200 &&
                        response.status < 300 &&
                        token;

                      if (isSuccess) {
                        localStorage.setItem("token", token);

                        if (user) {
                          localStorage.setItem("user", JSON.stringify(user));
                          localStorage.setItem("role", user.role);
                        }

                        let permissionsObject = {};

                        if (user?.role?.toUpperCase() === "ADMIN") {
                          permissionsObject = {
                            DASHBOARD: true,
                            CLINICS: true,
                            USERS: true,
                            POSTTEMPLATES: false,
                            MARKETING: false,
                            SUBSCRIPTION: false,
                            STAFF: true,
                          };
                        } else if (user?.role?.toUpperCase() === "SUPERADMIN") {
                          permissionsObject = {
                            DASHBOARD: true,
                            USERS: true,
                            MARKETING: true,
                            SUBSCRIPTION: true,
                            STAFF: false,
                            ORDER_LIST: true,
                            DELIVERED: true,
                            CATEGORY: true,
                            PRODUCT: true,
                            MENU: true,
                            TAX: true,
                            SIZE: true,
                            MATERIAL: true,
                            FONT: true,
                            COLOR: true,
                            TESTIMONIAL: true,
                            APPROVED: true,
                            COUPONS: true,
                            BULKORDER: true,
                            CONTACTUS: true,
                            BLOG: true,
                            BLOGCATEGORY: true,
                          };
                        } else if (permissionsRaw) {
                          if (Array.isArray(permissionsRaw)) {
                            permissionsObject = permissionsRaw.reduce(
                              (acc, item) => ({ ...acc, ...item }),
                              {},
                            );
                          } else if (typeof permissionsRaw === "object") {
                            permissionsObject = permissionsRaw;
                          }
                        }

                        localStorage.setItem(
                          "permissions",
                          JSON.stringify(permissionsObject),
                        );

                        setStatus({
                          success: "Login Successful",
                        });

                        // Redirect after a small delay
                        setTimeout(() => {
                          this.props.navigate("/");
                        }, 1000);

                        // Don't call setSubmitting(false) on success
                        return;
                      }

                      const backendError =
                        response?.error || response?.errors || null;

                      if (backendError && typeof backendError === "object") {
                        Object.keys(backendError).forEach((key) => {
                          setFieldError(key, backendError[key]);
                        });
                      } else {
                        this.setState({ loading: false });
                        setFieldError(
                          "authError",
                          response?.message || "Login failed",
                        );
                      }
                    } catch (error) {
                      this.setState({ loading: false });
                      const responseData = error?.response?.data;

                      const backendError =
                        responseData?.error || responseData?.errors || null;

                      if (backendError && typeof backendError === "object") {
                        Object.keys(backendError).forEach((key) => {
                          setFieldError(key, backendError[key]);
                        });
                      } else {
                        setFieldError(
                          "authError",
                          responseData?.message ||
                            "Login failed. Please try again.",
                        );
                      }

                      setSubmitting(false);
                    }
                  }}
                >
                  {({ touched, errors, isSubmitting, status }) => (
                    <Form>
                      {(errors.authError || status?.success) && (
                        <div
                          className={`alert ${
                            status?.success ? "alert-success" : "alert-danger"
                          }`}
                        >
                          {status?.success || errors.authError}
                        </div>
                      )}
                      {/* EMAIL */}
                      <div className="form-group">
                        <Field
                          type="email"
                          name="email"
                          placeholder="Enter email"
                          className={`form-control ${
                            touched.email && errors.email ? "is-invalid" : ""
                          }`}
                        />
                        <ErrorMessage
                          name="email"
                          component="small"
                          className="error"
                        />
                      </div>
                      {/* PASSWORD */}
                      <div className="form-group">
                        <Field
                          type="password"
                          name="password"
                          placeholder="Password"
                          className={`form-control ${
                            touched.password && errors.password
                              ? "is-invalid"
                              : ""
                          }`}
                        />
                        <ErrorMessage
                          name="password"
                          component="small"
                          className="error"
                        />
                      </div>
                      {/* SUBMIT */}
                      <div className="form-footer">
                        <button
                          type="submit"
                          className="btn btn-primary btn-block"
                          disabled={isSubmitting}
                        >
                          Login
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

function LoginWithRecaptcha(props) {
  const { executeRecaptcha } = useGoogleReCaptcha();

  return <Login {...props} executeRecaptcha={executeRecaptcha} />;
}

function LoginWrapper(props) {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
    >
      <LoginWithRecaptcha {...props} />
    </GoogleReCaptchaProvider>
  );
}

export default withRouter(LoginWrapper);
